// extracted by mini-css-extract-plugin
module.exports = {"headColumn":"CmsLargeAssetLeftHero_headColumn__7Rams"};